require("@rails/ujs").start()

import "./animations"
import "./menu"
import "./popups"
import "./expandables"
import "./radiobuttons"
import "./form"
import "./redirect"
import "./bvi"
// import "./calltouch"
